module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><defs><clipPath id=\"a\"><path d=\"M0 100h100V0H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\" transform=\"matrix(1.33333 0 0 -1.33333 -57.31 79.67)\"><path d=\"M59.65 49.15l-15.2-8.77a.98.98 0 0 0-1.47.85v17.54a.98.98 0 0 0 1.48.85l15.19-8.77c.3-.17.49-.5.49-.85a.97.97 0 0 0-.5-.85z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./static/images/play.svg
// module id = 3IGB
// module chunks = 1